<script lang="ts">
import { computed, defineComponent, onMounted, ref, toRaw, watch } from 'vue'
import { useEnhancer } from '@/app/enhancer'
import { useQuery } from '@/hooks/useHellooQuery'
import { useCustomization } from '@/hooks/useCustomization'
import { modelTypes } from '@/hooks/enums'
export default defineComponent({
  name: 'Default',
  props: {
    isBack: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ['done', 'error'],
  setup(_, { emit, expose }) {
    const {
      isLoading,
      isSuccess,
      data,
      fileData,
      isError,
      fetchList,
      uploadFile,
    } = useQuery()
    const { storeGlobalLoading, storeFavorites } = useEnhancer()
    const customization = useCustomization()
    const isFirstLoading = ref(true)
    const isLoadingBuildThumbnailUrl = ref(false)

    onMounted(() => {
      fetchList()
    })

    const loading = computed(() => {
      return (
        storeGlobalLoading.isLoading
        || isLoading.value
        || isLoadingBuildThumbnailUrl.value
      )
    })

    const loadingText = computed(() => {
      if (isLoadingBuildThumbnailUrl.value)
        return 'サムネイルURLを生成しています'

      return 'お待ちください'
    })

    const isRimlessModel = computed(() => {
      return (
        storeFavorites.selectedModel.value
          ?.split('_')
          ?.shift()
          ?.toLocaleUpperCase() === modelTypes.RIMLESS
      )
    })

    watch([isSuccess], () => {
      const rawData = toRaw(data.value)
      customization.setCustomization(rawData)
      isFirstLoading.value = false
    })

    watch(isError, () => {
      isFirstLoading.value = false
    })

    const triggerBuildThumbnailUrl = async (
      formData: FormData,
      eventType = '',
    ) => {
      try {
        isLoadingBuildThumbnailUrl.value = true
        await uploadFile(formData)
        storeFavorites.setCurrentConfig(
          'thumbnailUrl',
          fileData.value?.thumbnailUrl,
        )
        emit('done', eventType)
      }
      catch {
        emit('error', eventType)
      }
      finally {
        isLoadingBuildThumbnailUrl.value = false
      }
    }

    expose({
      triggerBuildThumbnailUrl,
    })

    return {
      loading,
      isFirstLoading,
      loadingText,
      isRimlessModel,
    }
  },
})
</script>

<template>
  <body>
    <div
      class="app-container shadow-7 bg-grey-5"
    >
      <slot name="header" />
      <slot />
      <div
        class="app-container__footer" :class="[isBack ? 'z-default' : 'z-over-vr']"
      >
        <slot name="footer" />
      </div>
    </div>
    <q-inner-loading class="z-top" :showing="loading">
      <q-spinner-ios v-if="isFirstLoading" color="primary" size="50px" />
      <template v-else>
        <q-spinner-gears size="50px" color="primary" />
        <q-item-label class="text-black text-subtitle1 q-mt-xs">
          {{ loadingText }}
        </q-item-label>
      </template>
    </q-inner-loading>
  </body>
</template>
